export const headerMenuData = {
  userNav: [
    {text: 'menu_account_settings', href: '/my-account/settings'},
    {text: 'menu_billing_and_payments', href: 'https://premium.wix.com/wix/api/PaymentConsole'},
    {text: 'menu_vouchers', href: 'https://premium.wix.com/wix/api/voucherConsole'},
  ],
  mobileNav: [
    {text: 'menu_home', href: '/'},
    {text: 'sub_menu_features', href: '/features/main', name: 'features'},
    {text: 'menu_explore', href: '/explore/websites', name: 'explore'},
    {text: 'sub_menu_upgrade_plans', href: '/upgrade/website', tab: 'PremiumPlans', name: 'upgrade_plans'},
    {
      text: 'footer_domains',
      href: '/domain/names',
      tab: 'Domains',
      name: 'domains'
    },
    {
      text: 'sub_menu_mailboxes',
      href: '/about/mailboxes',
      lang: ['de', 'zh', 'es', 'nl', 'no', 'pl', 'pt', 'ru', 'it', 'sv', 'ja', 'ko', 'tr', 'da', 'hi', 'cs', 'th', 'fr', 'uk'],
      tab: 'Mailboxes',
      name: 'mailboxes'
    },
    {text: 'sub_menu_mailboxes', href: '/business/email-address', lang: ['en'], tab: 'Mailboxes', name: 'mailboxes'},
    {text: 'sub_menu_templates', href: '/website/templates', tab: 'Templates', name: 'templates'},
    {
      text: 'menu_wix_mobile_app',
      href: 'https://apps.wix.com/mobile/v1/mobile-redirect/mobile-app?referrer=wix_mobile_home_tab',
      important: true,
    },
    {text: 'menu_partners', href: 'https://www.wix.com/partners', target: '_blank', lang: ['en'], important: true},
    {text: 'menu_support', href: 'https://support.wix.com/en/', target: '_blank', important: true},
    {text: 'wix_blog', href: 'https://www.wix.com/blog', target: '_blank', important: true, name: 'wix_blog'},
  ],
  nav: [
    {text: 'sub_menu_features', href: '/features/main', tab: 'Features', name: 'features'},
    {text: 'menu_explore', href: '/explore/websites', tab: 'Explore', name: 'explore'},
    {
      text: 'menu_subscriptions',
      href: '/upgrade/website',
      tab: 'Subscriptions',
      name: 'upgrade_plans',
      subs: [
        {text: 'sub_menu_upgrade_plans', href: '/upgrade/website', tab: 'PremiumPlans', name: 'upgrade_plans'},
        {
          text: 'footer_domains',
          href: '/domain/names',
          tab: 'Domains',
          name: 'domains'
        },
        {
          text: 'sub_menu_mailboxes',
          href: '/about/mailboxes',
          lang: ['de', 'zh', 'es', 'nl', 'no', 'pl', 'pt', 'ru', 'it', 'sv', 'ja', 'ko', 'tr', 'da', 'hi', 'cs', 'th', 'fr', 'uk'],
          tab: 'Mailboxes',
          name: 'mailboxes'
        },
        {text: 'sub_menu_mailboxes', href: '/business/email-address', lang: ['en'], tab: 'Mailboxes', name: 'mailboxes'},
      ],
    },
    {text: 'sub_menu_templates', href: '/website/templates', tab: 'Templates', name: 'templates'},
    {text: 'menu_partners', tab: 'Partners', name: 'partners', lang: ['en', 'fr', 'es', 'ja', 'pt', 'de', 'it', 'nl'],
      subs: [
        {text: 'sub_menu_become_a_partner', href: 'https://www.wix.com/partners', tab: 'BecomeWixPartner', name: 'become_wix_partner'},
        {text: 'sub_menu_hire_partner', href: 'https://www.wix.com/marketplace?utm_source=hp-menu', tab: 'HirePartner', name: 'hire_partner'},
      ],
    },
    {text: 'menu_editorx', href: 'https://www.editorx.com/?referralAdditionalInfo=wixheader', target: '_blank', tab: 'EditorX', name: 'editorX', lang: 'en'},
    {text: 'menu_support', href: 'https://support.wix.com/en/', target: '_blank', tab: 'Support', name: 'support'},
  ],
};
